import { usePage } from '@inertiajs/vue3'

export function usePermissions() {
    const { props } = usePage()

    /**
     * Check if user has a specific permission.
     * Permission format: {action}_{resource} (e.g., 'view_borrowing', 'create_product')
     */
    const canAccess = (permission) => {
        if (!permission) return true // No permission required

        // Guard against missing auth data (e.g., on error pages)
        if (!props.auth?.can) return false

        const parts = permission.split('_')
        const action = parts.shift() // get the FIRST part (view, create, update, delete)
        const model = parts.join('_') // join the rest (borrowing, cash-transaction, etc.)

        const hasPermission = props.auth.can[model]?.[action] ?? false

        // Debug logging (remove in production)
        if (import.meta.env.DEV && !props.auth.can[model]) {
            console.warn(`Permission model '${model}' not found in auth.can`)
        }

        return hasPermission
    }

    const canAccessAny = (permissions) => {
        return permissions.some((permission) => canAccess(permission))
    }

    const canAccessAll = (permissions) => {
        return permissions.every((permission) => canAccess(permission))
    }

    const getAllPermissions = () => {
        return props.auth.can || {}
    }

    const can = (model, action) => {
        return props.auth.can[model]?.[action] ?? false
    }

    return {
        canAccess,
        canAccessAny,
        canAccessAll,
        getAllPermissions,
        can,
    }
}
